import React from "react";
import PropTypes from "prop-types";
import { CardExpiryElement } from "@stripe/react-stripe-js";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  stripeElement: {
    borderColor: "#E8EAEF !important",
    borderStyle: "solid !important",
    borderWidth: 1,
    height: 48,
    fontSize: theme.typography.pxToRem(14),
    padding: "12px 8px",
    ".StripeElement--focus": {
      boxShadow: "0 1px 3px 0 #cfd7df",
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
}));
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#0000008a",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#0000008a",
      },
      iconColor: "#4187B6",
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

export default function CardExpiry({ disabled }) {
  const classes = useStyles();
  return (
    <CardExpiryElement
      options={{ ...CARD_ELEMENT_OPTIONS, disabled }}
      className={classes.stripeElement}
    />
  );
}

CardExpiry.propTypes = {
  disabled: PropTypes.bool,
};

CardExpiry.defaultProps = {
  disabled: false,
};
